import { useTranslation } from "react-i18next";
import { DOWNLOAD_APP_URL } from "@/utils/downloadApp";
import { captureEvent } from "@/utils/posthog";

export const DOWNLOAD_APP_CTA_CLEARANCE_CLASS = "pb-28";

export default function DownloadAppCta() {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 border-t border-zinc-200 bg-white/95 px-6 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <a
        href={DOWNLOAD_APP_URL}
        onClick={() => captureEvent("download_app_cta_click", { surface: "mobile_web" })}
        className="dp-button-primary w-full px-8 py-4 text-base"
      >
        {t("common.download_app")}
      </a>
    </div>
  );
}
